// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","removeMachineHeaderContainer":"styles_removeMachineHeaderContainer__15Xnl","removeMachineBodyContainer":"styles_removeMachineBodyContainer__2w4B0"};